import tclocal from './ter-consts-local-lib';
import { _getParamsFromLib } from './ter-params-utils';
import { _virbom_manipulator } from '../utils/frfr-virbom-manipulator-utils';
import { virbomCounter } from '../utils/frfr-virbom-counter-utils';
import { protobomp_manipulator } from '../utils/frfr-protobomp-utils';
import { terProtobompUtils_make_protobomp_manifest_terkk_latest, terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM } from './ter-protobomp-utils';
import { terUtilsNumberRoundUp, terUtils_get_naziv_materijala_by_ident } from './ter-utils';
import { _getParamsFromLibMaterijalLimParams } from './ter-materijal-utils';
import { js_utils } from '../utils/frfr-js-utils';
import { _derivat_demper_izracunaj_brojkrilaca } from './ter-derivat-lib-terkk-demper';
import { MINUS, TAB_CHARACTER } from '../utils/frfr-string-consts';
import { ROUND } from '../utils/excel-functions-utils';
import { _derivatModulDimenzije_sve_unutrasnje_iz_spoljasnje } from './ter-derivat-lib-terkk-uni-dimenzije';


/*
TODO


*/

export const derDraftel_terkk_ppd_pripremi_pods_input_inherited_za_draftel = (virtel_k, virtel_m) => {
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const pods_input_inherited = {
    // ...draftel_codecs_pack_terkk$_bundle_ppv.default_preset_state(),
    tipkomore: virtel_k.tipkomore,
    // unutrasnjaoplata: virtel_k.unutrasnjaoplata,
    vrstaprofila: virtel_m.vrstaprofila,
    // msirinaunutrasnjaizmedjupregradnih: virtel_m.msirinaunutrasnjaizmedjupregradnih,
    // msirinaunutrasnjaizmedjuosnovnih: virtel_m.msirinaunutrasnjaizmedjuosnovnih,
    // mvisinaunutrasnjaizmedjupregradnih: virtel_m.mvisinaunutrasnjaizmedjupregradnih,
    // mvisinaunutrasnjaizmedjuosnovnih: virtel_m.mvisinaunutrasnjaizmedjuosnovnih,
    // NJ 2024-12-20: Koristimo samo spoljašnje dimenzija modula za pods_input
    msirinaspoljasnja: virtel_m.msirinaspoljasnja,
    mvisinaspoljasnja: virtel_m.mvisinaspoljasnja,
  };
  return pods_input_inherited;
};


//
export const _derivat_terkk_ppd_izracunaj_materijale = (pods_input, cparams_combined) => {
  //
  const tipkomore = pods_input.tipkomore;
  //
  let _cpci = {};
  if (cparams_combined && cparams_combined.terkk_materijal_ident && js_utils.is_object(cparams_combined.terkk_materijal_ident)) { // validate cparams TODO
    // By cparmas
    _cpci = cparams_combined.terkk_materijal_ident;
  }
  //
  let tipmetalalima = "pocinkovani";
  if (tipkomore === "HYGIENE:pro") {
    tipmetalalima = "prohrom";
  } else {
    tipmetalalima = "pocinkovani";
  }
  //
  let ppd_materijal_lim = null;
  if (tipmetalalima === "pocinkovani") {
    ppd_materijal_lim = _cpci.ppd_materijal_lim_pocinkovani;
  }
  if (tipmetalalima === "prohrom") {
    ppd_materijal_lim = _cpci.ppd_materijal_lim_prohrom;
  }
  //
  return {
    tipmetalalima,
    ppd_materijal_lim,
  };
};


// OLD ne koristi se
const _OLD_derivat_terkk_ppd_izracunaj_sirina_visina = (msirinaunutrasnjaizmedjupregradnih, mvisinaunutrasnjaizmedjupregradnih) => {
  //
  const ZAZOR_2mm = 2;

  // polje njegova konacna sirina koja ce se dobiti kad se msirinaunutrasnjhaizmejdupoegradnih - 2mm.
  // visina panela mvisinunutrasnjaizmejdupregradnih - 2mm.

  let ppd_sirina = 0;
  let ppd_visina = 0;
  if (msirinaunutrasnjaizmedjupregradnih > 0) {
    ppd_sirina = msirinaunutrasnjaizmedjupregradnih - ZAZOR_2mm;
  }
  if (mvisinaunutrasnjaizmedjupregradnih > 0) {
    ppd_visina = mvisinaunutrasnjaizmedjupregradnih - ZAZOR_2mm;
  }

  return {
    ppd_sirina,
    ppd_visina
  };
};


// izracunavanje za wiz step 2
export const _derivat_terkk_ppd_izracunaj_dimenzije_otvora = (state, pods_input) => {
  //
  const {
    // msirinaunutrasnjaizmedjupregradnih,
    // msirinaunutrasnjaizmedjuosnovnih,
    // mvisinaunutrasnjaizmedjupregradnih,
    // mvisinaunutrasnjaizmedjuosnovnih,
    // NJ 2024-12-20: Koristimo samo spoljašnje dimenzija modula za pods_input
    vrstaprofila,
    msirinaspoljasnja,
    mvisinaspoljasnja,
  } = pods_input;
  const {
    ppd_isnapregradnom,
  } = state;
  //
  const {
    unutrasnjaIzmedjuPregradnih: msirinaunutrasnjaizmedjupregradnih, // preimenujemo  u msirinaunutrasnjaizmedjupregradnih
    unutrasnjaIzmedjuOsnovnih: msirinaunutrasnjaizmedjuosnovnih, // preimenujemo  u msirinaunutrasnjaizmedjuosnovnih
  } = _derivatModulDimenzije_sve_unutrasnje_iz_spoljasnje(msirinaspoljasnja, vrstaprofila);
  const {
    unutrasnjaIzmedjuPregradnih: mvisinaunutrasnjaizmedjupregradnih, // preimenujemo  u mvisinaunutrasnjaizmedjupregradnih
    unutrasnjaIzmedjuOsnovnih: mvisinaunutrasnjaizmedjuosnovnih, // preimenujemo  u mvisinaunutrasnjaizmedjuosnovnih
  } = _derivatModulDimenzije_sve_unutrasnje_iz_spoljasnje(mvisinaspoljasnja, vrstaprofila);
  //
  //
  let ppd_sirinaotvorazaugradnju = null;
  let ppd_visinaotvorazaugradnju = null;
  if (ppd_isnapregradnom === "DA") {
    // širina otvora za ugradnju (nasleđuje se od &msirinaunutrasnjaizmedjupregradnih, &msirinaunutrasnjaizmedjuosnovnih zavisno od toga da li se nalazi na pregradnom ili na osnovnom profilu )
    ppd_sirinaotvorazaugradnju = msirinaunutrasnjaizmedjupregradnih;
    // Visina otvora za ugradnju (nasleđuje se od &mvisinaunutrasnjaizmedjupregradnih, &mvisinaunutrasnjaizmedjuosnovnih zavisno od toga da li se nalazi na pregradnom ili na osnovnom profilu )
    ppd_visinaotvorazaugradnju = mvisinaunutrasnjaizmedjupregradnih;
  }
  if (ppd_isnapregradnom === "NE") {
    ppd_sirinaotvorazaugradnju = msirinaunutrasnjaizmedjuosnovnih;
    ppd_visinaotvorazaugradnju = mvisinaunutrasnjaizmedjuosnovnih;
  }
  //
  return {
    ppd_sirinaotvorazaugradnju,
    ppd_visinaotvorazaugradnju,
    ppd_sirinaotvorazaugradnju_preporucena: ppd_sirinaotvorazaugradnju,
    ppd_visinaotvorazaugradnju_preporucena: ppd_visinaotvorazaugradnju,
    ppv_customdimenzije: false,
  };
};


// izracunavanje za wiz step 3
export const _derivat_terkk_ppd_izracunaj_abcde = (state, pods_input) => {
  //
  const {
  } = pods_input;
  const {
    // ppd_sirinaotvorazaugradnju,
    // ppd_visinaotvorazaugradnju,
    ppd_unutrasnjasirinadempera_a,
    ppd_unutrasnjavisinadempera_c,
    ppd_rastojanjeodbocnestranedootvora,
    ppd_rastojanjeoddnadootvora,
  } = state;
  //
  const {
    ppd_sirinaotvorazaugradnju,
    ppd_visinaotvorazaugradnju,
  } = _derivat_terkk_ppd_izracunaj_dimenzije_otvora(state, pods_input);
  //
  //
  const ppd_b = ppd_sirinaotvorazaugradnju - 2;
  const ppd_h = ppd_visinaotvorazaugradnju - 2;
  // let ppd_a = ppd_unutrasnjasirinadempera_a;
  // let ppd_c = ppd_unutrasnjavisinadempera_c;
  // F=$Rastojanje od dna do otvora F-1
  const ppd_f = ppd_rastojanjeoddnadootvora - 1;
  // G=$Rastojanje od bočne strane do otvora G-1
  const ppd_g = ppd_rastojanjeodbocnestranedootvora - 1;
  // I=B-A-G-1
  const ppd_i = ppd_b - ppd_unutrasnjasirinadempera_a - ppd_g - 1;
  //
  return {
    // ppd_unutrasnjasirinadempera_a,
    // ppd_unutrasnjavisinadempera_c,
    // Zaoukruživanje radimo sa ROUND na dve decimale.
    ppd_b: ROUND(ppd_b, 2),
    ppd_h: ROUND(ppd_h, 2),
    ppd_f: ROUND(ppd_f, 2),
    ppd_g: ROUND(ppd_g, 2),
    ppd_i: ROUND(ppd_i, 2),
    //
    ppd_sirinaotvorazaugradnju: ROUND(ppd_sirinaotvorazaugradnju, 2),
    ppd_visinaotvorazaugradnju: ROUND(ppd_visinaotvorazaugradnju, 2),
  };
};


//
export const _derivat_terkk_ppd_solidworks_export_string_make = (state) => {
  const {

  } = state;
  //
  let ident = '?';
  //
  //
  const arr_to_export = [
    ident,

  ];
  const string_to_export = arr_to_export.join(TAB_CHARACTER);
  return string_to_export;
};


//
export const _derivat_terkk_ppd_pbnode_dirty_enrich = (pbnode_state_ref, protobomp_superdata, is_init) => {
  // DIRTY ENRICH
  // TODO ...props super superProps
  // console.log('item_ref, protobomp_superdata', item_ref, protobomp_superdata);
  const item = pbnode_state_ref;
  const family = item.pbnode_family;
  let povrsina = -1;
  let _cnc = null;
  let _naziv = null;
  let _materijal = '?'; // item.identmaterijala
  let _naziv_profil_komore_50_ili_70 = '?';
  let _naziv_tip_kadice = '?';
  let _tip_klizaca_abc = '?';
  let _tip_kadice = '?';
  let _strana_maske = '?';
  let _sufix = '?';
  let _visina_20_ili_35 = -1;
  /*
  Gde su: 

  */
  //
  const _mat_params = _getParamsFromLibMaterijalLimParams(item.identmaterijala);
  if (is_init === true) {
    if (typeof _mat_params.naziv === 'string') {
      item.naziv_materijala = _mat_params.naziv; // DIRTY
    } else {
      item.naziv_materijala = ''; // DIRTY
    }
  }
  const _tipmetalalima = _mat_params?.naziv_materijala;
  if (_tipmetalalima === "Prohrom") {
    _materijal = "SS";
  }
  if (_tipmetalalima === "Pocinkovani") {
    _materijal = "GS";
  }
  //
  const {
    ppd_sirinaotvorazaugradnju,
    ppd_visinaotvorazaugradnju,
    ppd_unutrasnjasirinadempera_a,
    ppd_unutrasnjavisinadempera_c,
    ppd_rastojanjeodbocnestranedootvora,
    ppd_rastojanjeoddnadootvora,
    ppd_b,
    ppd_h,
    ppd_i,
    ppd_f,
    ppd_g,
    //
    ppd_materijal_lim,
  } = protobomp_superdata;
  //

  const ppd_brojkrilaca = _derivat_demper_izracunaj_brojkrilaca(ppd_unutrasnjavisinadempera_c);

  //
  if (true) {
    // sklop
    if (family === 'terkk$ppd/SKLOP_PPD') { // 1. Odnosi se na sklop pregradnog panela dempera
      /*
      Naziv: "PREGRADNI PANEL DEMPERA P:" $B "x" $H " D:" $A "x" $C
      količina: $količina
      Jedinica mere: kom
      Operacija 1: Sklapanje
      Radni centar 1: Finalizacija
      */
      item.distinction_key = "terkk$PPD/SKLOP_PPD"; // DIRTY
      item.tip = "A"; // DIRTY
      _naziv = "PREGRADNI PANEL DEMPERA P:" + ppd_b + "x" + ppd_h + " D:" + ppd_unutrasnjasirinadempera_a + "x" + ppd_unutrasnjavisinadempera_c; //
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSKL"; // DIRTY
      item.rc1 = "GRCFIN"; // DIRTY
      //
      item.ppd_b = ppd_b; // DIRTY // sirina
      item.ppd_h = ppd_h; // DIRTY // visina
      item.ppd_unutrasnjasirinadempera_a = ppd_unutrasnjasirinadempera_a; // DIRTY
      item.ppd_unutrasnjavisinadempera_c = ppd_unutrasnjavisinadempera_c; // DIRTY
      item.ppd_g = ppd_g; // DIRTY
      item.ppd_i = ppd_i; // DIRTY
      item.ppd_f = ppd_f; // DIRTY
    }
    //
    if (family === 'terkk$ppd/P1') { // 2. P1
      /*
      Naziv: "PREGRADNI PANEL DEMPERA P1"
      Komada: 1
      Dim 1: $A
      Dim. 2: $H-$F-$C
      Površina: razvijena 1*razvijena 2
      razvijena 1: $A + 53,6 // Izmena 05.12.2024 Pogrešan parametar $L sam koristio.
      Razvijena 2: ($H-$F-$C) + 53,6
      Operacija 1: Probijanje
      Radni centar 1: RC-AMADA
      Operacija 2: Savijanje
      Radni centar 2: RC-ERMAKSAN
      Materijal: LC00000J ako je tip komore higijenik ELSE LB00000J
      CNC crtez: "P01-12-A-"$ppd_b"x"ppd_h"-"$ppd_unutrasnjasirinadempera_a"x"$Broj krilaca"-"$ppd_g"-"$ppd_f"-P1" // Izmena 04/12 nije postojala ova linija.
      */
      item.distinction_key = "terkk$PPD/A_P1"; // DIRTY
      item.tip = "A-P1"; // DIRTY
      _naziv = "PREGRADNI PANEL DEMPERA P1"; //
      item.kolicina = 1; // DIRTY
      item.dimenzija1 = ppd_unutrasnjasirinadempera_a; // DIRTY
      item.dimenzija2 = ppd_h - ppd_f - ppd_unutrasnjavisinadempera_c; // DIRTY
      item.razvijenamera1 = ppd_unutrasnjasirinadempera_a + 53.6; // DIRTY
      item.razvijenamera2 = (ppd_h - ppd_f - ppd_unutrasnjavisinadempera_c) + 53.6; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      item.identmaterijala = ppd_materijal_lim; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
      _cnc = "P01-12-A-" + ppd_b + "x" + ppd_h + MINUS + ppd_unutrasnjasirinadempera_a + "x" + ppd_brojkrilaca + MINUS + ppd_g + MINUS + ppd_f + "-P1";
      //
      item.ppd_unutrasnjasirinadempera_a = ppd_unutrasnjasirinadempera_a; // DIRTY
      item.ppd_f = ppd_f; // DIRTY
    }
    //
    if (family === 'terkk$ppd/P2') { // 3. P2
      /*
      Naziv: "PREGRADNI PANEL DEMPERA P2"
      Komada: 1
      Dim 1: $G
      Dim. 2: $H
      Površina: razvijena 1*razvijena 2
      razvijena 1: $G + 53,6
      Razvijena 2: $H + 53,6
      Operacija 1: Probijanje
      Radni centar 1: RC-AMADA
      Operacija 2: Savijanje
      Radni centar 2: RC-ERMAKSAN
      Materijal: LC00000J ako je tip komore higijenik ELSE LB00000J
      CNC crtez: "P01-12-A-"$ppd_b"x"ppd_h"-"$ppd_unutrasnjasirinadempera_a"x"$Broj krilaca"-"$ppd_g"-"$ppd_f"-P2"
      */
      item.distinction_key = "terkk$PPD/A_P2"; // DIRTY
      item.tip = "A-P2"; // DIRTY
      _naziv = "PREGRADNI PANEL DEMPERA P2"; //
      item.kolicina = 1; // DIRTY
      item.dimenzija1 = ppd_g; // DIRTY
      item.dimenzija2 = ppd_h; // DIRTY
      item.razvijenamera1 = ppd_g + 53.6; // DIRTY
      item.razvijenamera2 = ppd_h + 53.6; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      item.identmaterijala = ppd_materijal_lim; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
      _cnc = "P01-12-A-" + ppd_b + "x" + ppd_h + MINUS + ppd_unutrasnjasirinadempera_a + "x" + ppd_brojkrilaca + MINUS + ppd_g + MINUS + ppd_f + "-P2";
      //
      item.ppd_h = ppd_h; // DIRTY // visina
      item.ppd_g = ppd_g; // DIRTY
    }
    //
    if (family === 'terkk$ppd/P3') { // 4. P3
      /*
      Naziv: "PREGRADNI PANEL DEMPERA P3"
      Komada: 1
      Dim 1: $A
      Dim. 2: $F
      Površina: razvijena 1*razvijena 2
      razvijena 1: $A + 53,6
      Razvijena 2: $F + 53,6
      Operacija 1: Probijanje
      Radni centar 1: RC-AMADA
      Operacija 2: Savijanje
      Radni centar 2: RC-ERMAKSAN
      Materijal: LC00000J ako je tip komore higijenik ELSE LB00000J
      CNC crtez: "P01-12-A-"$ppd_b"x"ppd_h"-"$ppd_unutrasnjasirinadempera_a"x"$Broj krilaca"-"$ppd_g"-"$ppd_f"-P3"
      */
      item.distinction_key = "terkk$PPD/A_P3"; // DIRTY
      item.tip = "A-P3"; // DIRTY
      _naziv = "PREGRADNI PANEL DEMPERA P3"; //
      item.kolicina = 1; // DIRTY
      item.dimenzija1 = ppd_unutrasnjasirinadempera_a; // DIRTY
      item.dimenzija2 = ppd_f; // DIRTY
      item.razvijenamera1 = ppd_unutrasnjasirinadempera_a + 53.6; // DIRTY
      item.razvijenamera2 = ppd_f + 53.6; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      item.identmaterijala = ppd_materijal_lim; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
      _cnc = "P01-12-A-" + ppd_b + "x" + ppd_h + MINUS + ppd_unutrasnjasirinadempera_a + "x" + ppd_brojkrilaca + MINUS + ppd_g + MINUS + ppd_f + "-P3";
      //
      item.ppd_unutrasnjasirinadempera_a = ppd_unutrasnjasirinadempera_a; // DIRTY
      item.ppd_f = ppd_f; // DIRTY
    }
    //
    if (family === 'terkk$ppd/P4') { // 5. P4
      /*
      Naziv: "PREGRADNI PANEL DEMPERA P4"
      Komada: 1
      Dim 1: $I
      Dim. 2: $H
      Površina: razvijena 1*razvijena 2
      razvijena 1: $I + 53,6
      Razvijena 2: $H + 53,6
      Operacija 1: Probijanje
      Radni centar 1: RC-AMADA
      Operacija 2: Savijanje
      Radni centar 2: RC-ERMAKSAN
      Materijal: LC00000J ako je tip komore higijenik ELSE LB00000J
      CNC crtez: "P01-12-A-"$ppd_b"x"ppd_h"-"$ppd_unutrasnjasirinadempera_a"x"$Broj krilaca"-"$ppd_g"-"$ppd_f"-P4"
      */
      item.distinction_key = "terkk$PPD/A_P4"; // DIRTY
      item.tip = "A-P4"; // DIRTY
      _naziv = "PREGRADNI PANEL DEMPERA P4"; //
      item.kolicina = 1; // DIRTY
      item.dimenzija1 = ppd_i; // DIRTY
      item.dimenzija2 = ppd_h; // DIRTY
      item.razvijenamera1 = ppd_i + 53.6; // DIRTY
      item.razvijenamera2 = ppd_h + 53.6; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2; //
      item.identmaterijala = ppd_materijal_lim; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
      _cnc = "P01-12-A-" + ppd_b + "x" + ppd_h + MINUS + ppd_unutrasnjasirinadempera_a + "x" + ppd_brojkrilaca + MINUS + ppd_g + MINUS + ppd_f + "-P4";
      //
      item.ppd_h = ppd_h; // DIRTY // visina
      item.ppd_i = ppd_i; // DIRTY
    }
    //
    //
  }
  // 
  if (povrsina > -1) {
    item.povrsina = terUtilsNumberRoundUp((povrsina / 1000000), 2); // konvertovana u m2 i zaokruzeno na 2 decimale // DIRTY
  }
  if (_cnc) {
    item.cnccrtez = _cnc; // DIRTY
  }
  if (_naziv) {
    item.naziv = _naziv; // DIRTY
  }
  //
  return item;
};


//
export const _derivat_terkk_ppd_izracunaj_za_step_protobomp = (state, pods_input) => {
  console.log('_derivat_terkk_ppd_izracunaj_za_step_protobomp state', state);
  //
  const {

  } = pods_input;
  const {
    ppd_sirinaotvorazaugradnju,
    ppd_visinaotvorazaugradnju,
    ppd_unutrasnjasirinadempera_a,
    ppd_unutrasnjavisinadempera_c,
    ppd_rastojanjeodbocnestranedootvora,
    ppd_rastojanjeoddnadootvora,
    ppd_b,
    ppd_h,
    ppd_i,
    ppd_f,
    ppd_g,
    //
    ppd_materijal_lim,
    kolicina,
  } = state;

  // TODO
  const protobomp_superdata = {
    ppd_sirinaotvorazaugradnju,
    ppd_visinaotvorazaugradnju,
    ppd_unutrasnjasirinadempera_a,
    ppd_unutrasnjavisinadempera_c,
    ppd_rastojanjeodbocnestranedootvora,
    ppd_rastojanjeoddnadootvora,
    ppd_b,
    ppd_h,
    ppd_i,
    ppd_f,
    ppd_g,
    //
    ppd_materijal_lim,
  };
  //

  ////
  //
  // const I = ppd_sirina - ppd_g - unutrasnjasirina; // I = G - A;
  // 

  //
  // _subform_arr
  let _arr = [];
  let _protobomp = protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$ppd"), protobomp_superdata);
  //
  //
  const _pbnode_dirty_enrich = _derivat_terkk_ppd_pbnode_dirty_enrich; // TODO
  // ----- kreiranje sklopova
  //
  const _sklop_uzor = {
  };
  let _temp_sklop;
  let _temp_pbnode;
  _temp_sklop = {
    ..._sklop_uzor,
    pbnode_family: 'terkk$ppd/SKLOP_PPD',
    naziv: '* SKLOP PPD',
    kolicina: kolicina,
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true }, 'SKLOP_PPD');
  const { created_tempkey: sklop_ppd } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  //
  // ----- dodavanje primitivnih u sklopove
  //

  //
  if (true) {
    //
    if (true) { // 2. P1 PREGRADNI PANEL DEMPERA P1
      const item = {
        /*
        tempkey: 101,
        ppd_oznaka: "P1", // gornji
        naziv: "P1",
        sirina: unutrasnjasirina, // 
        visina: ((ppd_visina - unutrasnjavisina) / 2), //
        */
        tempkey: 1,
        pbnode_family: 'terkk$ppd/P1',
        identmaterijala: ppd_materijal_lim,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      // _arr.push(item);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_ppd);
    }
    //
    if (true) { // 3. P2 PREGRADNI PANEL DEMPERA P2
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$ppd/P2',
        identmaterijala: ppd_materijal_lim,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      // _arr.push(item);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_ppd);
    }
    //
    if (true) { // 4. P3 PREGRADNI PANEL DEMPERA P3
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$ppd/P3',
        identmaterijala: ppd_materijal_lim,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      // _arr.push(item);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_ppd);
    }
    //
    if (true) { // 5. P4 PREGRADNI PANEL DEMPERA P4
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$ppd/P4',
        identmaterijala: ppd_materijal_lim,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      // _arr.push(item);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_ppd);
    }

    //
  }

  //
  //
  return {
    svasta: {},
    _arr,
    _protobomp,
  }; // TODO
};


// ---------- VIRBOM DERIVATS ----------


export const derAutoCreateVirbom_terkk_ppd_prepare_vir_input = (p) => {
  // TODO
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const v_input = {
    p: p,


  };
  return v_input;
};


export const derAutoCreateVirbom_terkk_ppd_children = (v_input) => {
  console.log('derivatAutoCreateVirbom_ppd_children(v_input) ');
  console.log(v_input);

  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva
  let xm = {}; // JOCKER promenjiva
  let xx = {}; // JOCKER promenjiva
  let xxm = {}; // JOCKER promenjiva
  let _derivat_key;
  let _mat;
  let _materijal_naziv;


  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  console.log(z);


  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  console.log('der_virbom_seq');
  console.log(virbom_seq);
  return virbom_seq;
};


